import Image from 'next/image';
import { promotionButtonStyles } from './promotion-button.style';
import { useTranslations } from 'next-intl';
import { useAthenaCustomSetting } from '@/hooks/query/athena/use-athena-custom-setting';
import { windowService } from '@/services/jupiter/window-service';
import windowNameKeys from '@/constants/window-name-keys';


export const PromotionButton = () => {
	const t = useTranslations('General');
	const { data: athenaCustomSetting } = useAthenaCustomSetting();

	const openPromotion = () => {
		if (athenaCustomSetting?.PromotionUrl) {
			windowService.openWindow(windowNameKeys.PROMOTION, athenaCustomSetting.PromotionUrl, '_blank');
		}
	}

	return athenaCustomSetting?.PromotionUrl ? (
		<div className={promotionButtonStyles.button} onClick={openPromotion}>
			<div className={promotionButtonStyles.icon}>
				<Image
					src={'/images/sign-up/promotion.png'}
					alt="promotion"
					width={32}
					height={38}
				/>
			</div>
			<div className={promotionButtonStyles.text}>{t('lbl_Promotion')}</div>
		</div>
	) : null;
};

